export default "__VITE_ASSET__DaEyVN24__"